import config from '../config';
import axios from 'axios';
import decode from 'jwt-decode';
import router from '../router';

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: '',
    currentUser: null,
  },
  mutations: {
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
      state.currentUser = null;
    },
    LOGIN_SUCCESS(state, user) {
      //ลงชื่อเข้าใช้สำเร็จ
      state.isFetching = false;
      state.errorMessage = '';
      state.currentUser = user || null;
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
    },
  },
  actions: {
    async findMe({ dispatch }) {
      try {
        const response = await axios.get('/auth/me');
        //ค้นหาฉัน
        //add data to localStorage
        localStorage.setItem('user_data', JSON.stringify(response.data));

        return response.data;
      } catch (e) {
        dispatch('snackbar/showSnackbar', e, { root: true });
        dispatch('logoutUser');
      }
    },
    async doInit({ dispatch, commit }) {
      try {
        let currentUser = null;
        let token = localStorage.getItem('token');

        // ✅ เช็คเวลา login_at ถ้าเกิน 8 ชั่วโมงให้ logout
        const loginAt = Number(localStorage.getItem('login_at') || 0);
        const maxAge = 8 * 60 * 60 * 1000; // 8 ชั่วโมง (ms)
        if (loginAt && Date.now() - loginAt > maxAge) {
          // token หมดอายุแล้ว
          dispatch('logoutUser');
          return;
        }

        if (token) {
          currentUser = await dispatch('findMe');
        }
        commit('LOGIN_SUCCESS', currentUser);
      } catch (e) {
        commit('LOGIN_FAILURE', e);
      }
    },
    async loginUser({ dispatch }, payload) {
      dispatch('requestLogin');

      //ลงชื่อเข้าใช้  เช็ค social หรือเป็นแบบ กรอก user pass
      if (payload.social) {
        window.location.href =
            config.baseURLApi + '/auth/signin/' + payload.social;
      } else if (payload.email && payload.password) {
        try {
          const res = await axios.post('/auth/signin/local', payload);
          const token = res.data;
          dispatch('receiveToken', token);
          dispatch('doInit');
        } catch (e) {
          dispatch('snackbar/showSnackbar', e, { root: true });
          dispatch('loginError', e.response.data);
        }
      } else {
        dispatch('loginError', 'Something was wrong. Try again');
      }
    },
    receiveToken({ commit }, token) {
      let user = decode(token);

      //ลงชื่อเข้าใช้

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      // ✅ เก็บเวลา login_at ไว้เช็คอายุ 8 ชั่วโมง
      localStorage.setItem('login_at', String(Date.now()));

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      commit('LOGIN_SUCCESS');
      router.push('/');
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('user_data');
      // ✅ ลบ login_at ด้วย
      localStorage.removeItem('login_at');

      axios.defaults.headers.common['Authorization'] = '';
      router.push('/login');
    },
    loginError({ commit }, payload) {
      commit('LOGIN_FAILURE', payload);
    },
    requestLogin({ commit }) {
      commit('LOGIN_REQUEST');
    },
    receiveLogin({ commit }) {
      commit('LOGIN_SUCCESS');
    },
  },
};
